import { useEventTypes } from './useEventTypes';

export const useMatchesEventTypes = () => {
  const eventTypes = useEventTypes();

  const matchesEventTypes = eventTypes?.filter((item) => item.identifier.includes('_MATCH')) || [];

  return matchesEventTypes;
};
